// Home.jsx – Enhanced Design With Styled Text
import { motion } from 'framer-motion';

const Home = () => (
  <>
    <section style={{ padding: '3rem 1rem', background: 'linear-gradient(to right, #f8f8ff, #fafafe)', textAlign: 'center' }}>
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{ fontSize: 'clamp(1.8rem, 6vw, 2.5rem)', fontWeight: 'bold', color: '#6A0DAD', lineHeight: '1.3' }}
      >
        India's Credit Crisis Ends Here
      </motion.h1>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        style={{ maxWidth: '90%', margin: '1rem auto', fontSize: 'clamp(0.95rem, 4vw, 1.15rem)', color: '#333', lineHeight: '1.6' }}
      >
        <p style={{ marginBottom: '0.5rem' }}>
          <strong style={{ color: '#6A0DAD' }}>300M+ excluded.</strong> <br />
          <span style={{ color: '#444' }}>High interest. No access.</span>
        </p>
        <p>
          <span style={{ fontWeight: '500' }}>Pluto Loans is unlocking</span> <strong style={{ color: '#000' }}>₹500–₹50K</strong> loans via <strong>AI</strong> –
          <span style={{ fontStyle: 'italic' }}> no CIBIL, no paperwork</span>.
        </p>
      </motion.div>
      <a href="/pre-apply">
        <button style={{ backgroundColor: '#6A0DAD', color: 'white', padding: '12px 24px', borderRadius: '8px', border: 'none', fontSize: '1rem', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', marginTop: '1rem' }}>
          Pre-Apply Now
        </button>
      </a>
    </section>

    <section style={{ padding: '2rem 1rem', background: '#fff' }}>
      <h2 style={{ textAlign: 'center', color: '#6A0DAD', fontSize: '1.5rem' }}>Who We Serve</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem', marginTop: '2rem' }}>
        {[{
          title: 'Gig Workers',
          desc: 'UPI income, no salary slip? We got you covered.'
        }, {
          title: 'Students',
          desc: '₹1K–₹5K urgent needs? Fast approvals without credit history.'
        }, {
          title: 'Small Vendors',
          desc: 'Get ₹10K–₹30K for daily inventory, same-day disbursal.'
        }].map((card, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.2 }}
            style={{ background: '#f3f3ff', padding: '1.5rem', borderRadius: '12px', flex: '1 1 100%', maxWidth: '340px', textAlign: 'left', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}
          >
            <h4 style={{ color: '#6A0DAD', fontSize: '1.1rem', marginBottom: '0.5rem' }}>{card.title}</h4>
            <p style={{ fontSize: '0.95rem' }}>{card.desc}</p>
          </motion.div>
        ))}
      </div>
    </section>

    <section style={{ padding: '2rem 1rem', background: '#f8f8f8', textAlign: 'center' }}>
      <h2 style={{ color: '#6A0DAD', fontSize: '1.5rem' }}>Our Trusted Backers</h2>
      <p style={{ fontSize: '0.9rem', maxWidth: '90%', margin: '0.5rem auto' }}>We're in the process of onboarding trusted lending partners and fintech investors</p>
      <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '1rem', marginTop: '1.5rem' }}>
        {['RBI Regulated', 'Secure UPI Infra', 'PCI-DSS Compliant', 'Data Encrypted'].map((logo, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.2 }}
            style={{ background: 'white', padding: '1rem 1.5rem', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', flex: '1 1 40%', maxWidth: '220px', fontSize: '0.95rem' }}
          >
            {logo}
          </motion.div>
        ))}
      </div>
    </section>
  </>
);

export default Home;
